import React, { memo } from 'react';
import { ConstructorWidgetEnum } from '@perxis-auto/instock-sdk/lib/shared/types';
import { Constructor } from '@perxis-auto/instock-sdk/lib/shared/ui';
import { widget as benefitsWidget } from '@perxis-auto/instock-sdk/lib/widgets/benefits';
import { widget as benefitsFootnoteWidget } from '@perxis-auto/instock-sdk/lib/widgets/benefitsFootnote';
import { widget as bookingRequestWidget } from '@perxis-auto/instock-sdk/lib/widgets/bookingRequest';
import { widget as buttonWidget } from '@perxis-auto/instock-sdk/lib/widgets/button';
import { widget as cardWidget } from '@perxis-auto/instock-sdk/lib/widgets/card';
import { widget as cardActionsWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardActions';
import { widget as cardBookingButtonWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardBookingButton';
import { widget as cardImageWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardImage';
import { widget as cardLocationWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardLocation';
import { widget as cardMarkersWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardMarkers';
import { widget as cardPaymentWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardPayment';
import { widget as cardPriceWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardPrice';
import { widget as cardTableWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardTable';
import { widget as cardTitleWidget } from '@perxis-auto/instock-sdk/lib/widgets/cardTitle';
import { widget as comparisonEquipmentsWidget } from '@perxis-auto/instock-sdk/lib/widgets/comparisonEquipments';
import { widget as comparisonFooterWidget } from '@perxis-auto/instock-sdk/lib/widgets/comparisonFooter';
import { widget as comparisonHeaderWidget } from '@perxis-auto/instock-sdk/lib/widgets/comparisonHeader';
import { widget as comparisonListWidget } from '@perxis-auto/instock-sdk/lib/widgets/comparisonList';
import { widget as comparisonSpecificationsWidget } from '@perxis-auto/instock-sdk/lib/widgets/comparisonSpecifications';
import { widget as customWidget } from '@perxis-auto/instock-sdk/lib/widgets/custom';
import { widget as dealerCommentWidget } from '@perxis-auto/instock-sdk/lib/widgets/dealerComment';
import { widget as dealerMapWidget } from '@perxis-auto/instock-sdk/lib/widgets/dealerMap';
import { widget as equipmentsWidget } from '@perxis-auto/instock-sdk/lib/widgets/equipments';
import { widget as favoritesHeaderWidget } from '@perxis-auto/instock-sdk/lib/widgets/favoritesHeader';
import { widget as favoritesListWidget } from '@perxis-auto/instock-sdk/lib/widgets/favoritesList';
import { widget as filterHistoryWidget } from '@perxis-auto/instock-sdk/lib/widgets/filterHistory';
import { widget as filterItemWidget } from '@perxis-auto/instock-sdk/lib/widgets/filterItem';
import { widget as filterPanelWidget } from '@perxis-auto/instock-sdk/lib/widgets/filterPanel';
import { widget as financeWidget } from '@perxis-auto/instock-sdk/lib/widgets/finance';
import { widget as geoLocationDetectorWidget } from '@perxis-auto/instock-sdk/lib/widgets/geoLocationDetector';
import { widget as modelListWidget } from '@perxis-auto/instock-sdk/lib/widgets/modelList';
import { widget as tileWidget } from '@perxis-auto/instock-sdk/lib/widgets/tile';
import { widget as tileActionsWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileActions';
import { widget as tileGalleryWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileGallery';
import { widget as tileHeaderWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileHeader';
import { widget as tileImageWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileImage';
import { widget as tileLocationWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileLocation';
import { widget as tileMarkersWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileMarkers';
import { widget as tilePaymentWidget } from '@perxis-auto/instock-sdk/lib/widgets/tilePayment';
import { widget as tilePriceWidget } from '@perxis-auto/instock-sdk/lib/widgets/tilePrice';
import { widget as tileStatusWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileStatus';
import { widget as tileTableWidget } from '@perxis-auto/instock-sdk/lib/widgets/tileTable';
import { widget as vehicleHeaderWidget } from '@perxis-auto/instock-sdk/lib/widgets/vehicleHeader';
import { widget as vehiclesCatalogWidget } from '@perxis-auto/instock-sdk/lib/widgets/vehiclesCatalog';
import { widget as vehiclesCatalogHeaderWidget } from '@perxis-auto/instock-sdk/lib/widgets/vehiclesCatalogHeader';
import { widget as vehiclesHeaderWidget } from '@perxis-auto/instock-sdk/lib/widgets/vehiclesHeader';
import { widget as vehiclesListWidget } from '@perxis-auto/instock-sdk/lib/widgets/vehiclesList';

import { AppConstructorProps } from './AppConstructor.types';

export const AppConstructor = memo(function AppConstructor({ layout }: AppConstructorProps) {
  return (
    <Constructor<ConstructorWidgetEnum>
      layout={layout}
      widgets={{
        [ConstructorWidgetEnum.Button]: buttonWidget,
        [ConstructorWidgetEnum.Custom]: customWidget,

        [ConstructorWidgetEnum.VehiclesList]: vehiclesListWidget,
        [ConstructorWidgetEnum.VehicleHeader]: vehicleHeaderWidget,
        [ConstructorWidgetEnum.VehiclesCatalog]: vehiclesCatalogWidget,
        [ConstructorWidgetEnum.VehiclesCatalogHeader]: vehiclesCatalogHeaderWidget,
        [ConstructorWidgetEnum.VehiclesHeader]: vehiclesHeaderWidget,

        [ConstructorWidgetEnum.ModelList]: modelListWidget,

        [ConstructorWidgetEnum.Benefits]: benefitsWidget,
        [ConstructorWidgetEnum.BenefitsFootnote]: benefitsFootnoteWidget,
        [ConstructorWidgetEnum.DealerComment]: dealerCommentWidget,
        [ConstructorWidgetEnum.DealerMap]: dealerMapWidget,
        [ConstructorWidgetEnum.Equipments]: equipmentsWidget,
        [ConstructorWidgetEnum.Finance]: financeWidget,

        [ConstructorWidgetEnum.Tile]: tileWidget,
        [ConstructorWidgetEnum.TileActions]: tileActionsWidget,
        [ConstructorWidgetEnum.TileGallery]: tileGalleryWidget,
        [ConstructorWidgetEnum.TileHeader]: tileHeaderWidget,
        [ConstructorWidgetEnum.TileLocation]: tileLocationWidget,
        [ConstructorWidgetEnum.TileMarkers]: tileMarkersWidget,
        [ConstructorWidgetEnum.TilePayment]: tilePaymentWidget,
        [ConstructorWidgetEnum.TilePrice]: tilePriceWidget,
        [ConstructorWidgetEnum.TileStatus]: tileStatusWidget,
        [ConstructorWidgetEnum.TileImage]: tileImageWidget,
        [ConstructorWidgetEnum.TileTable]: tileTableWidget,

        [ConstructorWidgetEnum.Card]: cardWidget,
        [ConstructorWidgetEnum.CardActions]: cardActionsWidget,
        [ConstructorWidgetEnum.CardBookingButton]: cardBookingButtonWidget,
        [ConstructorWidgetEnum.CardImage]: cardImageWidget,
        [ConstructorWidgetEnum.CardLocation]: cardLocationWidget,
        [ConstructorWidgetEnum.CardMarkers]: cardMarkersWidget,
        [ConstructorWidgetEnum.CardPayment]: cardPaymentWidget,
        [ConstructorWidgetEnum.CardPrice]: cardPriceWidget,
        [ConstructorWidgetEnum.CardTable]: cardTableWidget,
        [ConstructorWidgetEnum.CardTitle]: cardTitleWidget,

        [ConstructorWidgetEnum.ComparisonEquipments]: comparisonEquipmentsWidget,
        [ConstructorWidgetEnum.ComparisonFooter]: comparisonFooterWidget,
        [ConstructorWidgetEnum.ComparisonHeader]: comparisonHeaderWidget,
        [ConstructorWidgetEnum.ComparisonList]: comparisonListWidget,
        [ConstructorWidgetEnum.ComparisonSpecifications]: comparisonSpecificationsWidget,

        [ConstructorWidgetEnum.FavoritesHeader]: favoritesHeaderWidget,
        [ConstructorWidgetEnum.FavoritesList]: favoritesListWidget,

        [ConstructorWidgetEnum.FilterPanel]: filterPanelWidget,
        [ConstructorWidgetEnum.FilterHistory]: filterHistoryWidget,

        [ConstructorWidgetEnum.FilterCheckboxGroup]: filterItemWidget,
        [ConstructorWidgetEnum.FilterColorPicker]: filterItemWidget,
        [ConstructorWidgetEnum.FilterDuoColorPicker]: filterItemWidget,
        [ConstructorWidgetEnum.FilterLocation]: filterItemWidget,
        [ConstructorWidgetEnum.FilterModels]: filterItemWidget,
        [ConstructorWidgetEnum.FilterOptions]: filterItemWidget,
        [ConstructorWidgetEnum.FilterSelect]: filterItemWidget,
        [ConstructorWidgetEnum.FilterMultipleSelect]: filterItemWidget,
        [ConstructorWidgetEnum.FilterRangeSlider]: filterItemWidget,
        [ConstructorWidgetEnum.FilterSlider]: filterItemWidget,

        [ConstructorWidgetEnum.BookingRequest]: bookingRequestWidget,

        [ConstructorWidgetEnum.GeoLocationDetector]: geoLocationDetectorWidget,
      }}
    />
  );
});
